import { createBrowserRouter, Navigate, useParams } from "react-router-dom";
import PaymentSuccess from "../Components/ChildComponents/PaymentSuccess";
import PaymentFail from "../Components/ChildComponents/PaymentFail";
import PaymentCancel from "../Components/ChildComponents/PaymentCancel";
import RecipePurchaseReturn from "../Components/ChildComponents/RecipePurchaseReturn";
import PrintComponent from "../Components/Common/Print/PrintComponent.jsx";
import HomeLayout from "../Components/RootComponents/HomeLayout.jsx";
import AboutUs from "../features/about-us/index.jsx";
import AllFoods from "../features/all-foods";
import AllChefs from "../features/all-chefs/index.jsx";
import AllKitchens from "../features/all-kitchens/index.jsx";
import AllRecipes from "../features/all-recipes/index.jsx";
import AuthContainer from "../features/auth/components/AuthContainer";
import BecomeMerchant from "../features/become-merchant/index.jsx";
import BecomeSeller from "../features/become-seller/index.jsx";
import CheckOut from "../features/checkout/index.jsx";
import ContactUs from "../features/contact-us/index.jsx";
import DeleteAccount from "../features/delete-account/index.jsx";
import EarnMoney from "../features/earn-money/index.jsx";
import FAQPage from "../features/faq/index.jsx";
import FoodDetails from "../features/food-details/index.jsx";
import Home from "../features/home";
import Invoice from "../features/invoice/index.jsx";
import KitchenProfilePage from "../features/kitchen-profile/index.jsx";
import MyOrders from "../features/my-orders/index.jsx";
import MyWishes from "../features/my-wishes/index.jsx";
import NotFound from "../features/not-found";
import Notifications from "../features/notifications/index.jsx";
import OrderDetails from "../features/order-details/index.jsx";
import OrderTracking from "../features/order-tracking/index.jsx";
import GoverningLaw from "../features/governing-law/index.jsx";
import PartnerPrivacyPolicy from "../features/partner-privacy-policy/index.jsx";
import PrivacyPolicy from "../features/privacy-policy/index.jsx";
import MyProfile from "../features/profile/index.jsx";
import RecipeDetails from "../features/recipe-details/index.jsx";
import SecurityPolicy from "../features/security-policy/index.jsx";
import TermsAndConditions from "../features/terms-and-conditions/index.jsx";
import UnderConstruction from "../features/under-construction/index.jsx";
import WishOrderPricing from "../features/wish-ordar-pricing/index.jsx";
import WishOrderForm from "../features/wish-order/index.jsx";
import PrivateRoute from "./PrivateRoute/PrivateRoute.jsx";

/**
 * Legacy `/Category/:id` links (search results, old bookmarks) now point at the
 * catalogue browse page, which filters by the same category id.
 */
const CategoryRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/all-food?categoryId=${id}`} replace />;
};

const RouterErrorPage = () => (
  <div
    className="container d-flex align-items-center justify-content-center flex-column"
    style={{ minHeight: "100vh" }}
  >
    <h1 className="display-1 fw-bold text-primary text-center">Oops!</h1>
    <p className="lead text-muted text-center">
      Something went wrong. Please go back and try again.
    </p>
    <a href="/" className="btn btn-primary mt-2">
      Go Home
    </a>
  </div>
);

export const routes = createBrowserRouter([
  {
    path: "/",
    element: <HomeLayout />,
    errorElement: <RouterErrorPage />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/all-food",
        element: <AllFoods />,
      },
      {
        path: "/all-kitchens",
        element: <AllKitchens />,
      },
      {
        path: "/all-chefs",
        element: <AllChefs />,
      },
      {
        path: "/SellerProfile/:id",
        element: <KitchenProfilePage />,
      },
      {
        path: "/food-details/:id",
        element: <FoodDetails />,
      },
      {
        path: "/Category/:id",
        element: <CategoryRedirect />,
      },
      {
        path: "/search",
        element: <Navigate to="/all-food" replace />,
      },
      {
        path: "/all-recipes",
        element: <AllRecipes />,
      },
      {
        path: "/about-us",
        element: <AboutUs />,
      },
      {
        path: "/contact-us",
        element: <ContactUs />,
      },
      {
        path: "/earn-money",
        element: <EarnMoney />,
      },
      {
        path: "/become-seller",
        element: <BecomeSeller />,
      },
      {
        path: "/become-merchant",
        element: <BecomeMerchant />,
      },
      {
        path: "/SingleRecipeCategoryAllFood/:id",
        element: <Navigate to="/all-recipes" replace />,
      },
      {
        path: "/recipe-details/:id",
        element: <RecipeDetails />,
      },
      {
        path: "/faq",
        element: <FAQPage />,
      },
      {
        path: "/CountryCategory",
        element: <Navigate to="/all-food" replace />,
      },
      {
        path: "/CustomerRegistration",
        element: <Navigate to="/authentication/register" replace />,
      },
      {
        path: "/FoodsDairyPage/",
        element: <Navigate to="/all-food" replace />,
      },
      {
        path: "/CheckOut",
        element: (
          <PrivateRoute>
            <CheckOut />
          </PrivateRoute>
        ),
      },
      {
        path: "/authentication/:step",
        element: <AuthContainer />,
      },
      {
        path: "/food",
        element: <Navigate to="/all-food" replace />,
      },
      {
        // Seller-side pages: the API scopes these to the chef role, and this app
        // is the customer surface, so they are not part of it any more.
        path: "/updateProfile",
        element: <Navigate to="/profile" replace />,
      },
      {
        path: "/updateProfile1",
        element: <Navigate to="/profile" replace />,
      },
      {
        path: "/catering-order",
        element: <Navigate to="/wish-order" replace />,
      },
      {
        path: "/profile",
        element: (
          <PrivateRoute>
            <MyProfile />
          </PrivateRoute>
        ),
      },
      {
        path: "/wish-order",
        element: (
          <PrivateRoute>
            <WishOrderForm />
          </PrivateRoute>
        ),
      },
      {
        path: "/my-wishes",
        element: (
          <PrivateRoute>
            <MyWishes />
          </PrivateRoute>
        ),
      },
      {
        path: "/wish-order-pricing",
        element: (
          <PrivateRoute>
            <WishOrderPricing />
          </PrivateRoute>
        ),
      },
      {
        path: "/my-orders",
        element: (
          <PrivateRoute>
            <MyOrders />
          </PrivateRoute>
        ),
      },
      {
        path: "/notifications",
        element: (
          <PrivateRoute>
            <Notifications />
          </PrivateRoute>
        ),
      },
      {
        path: "/order-details/:id",
        element: (
          <PrivateRoute>
            <OrderDetails />
          </PrivateRoute>
        ),
      },
      {
        path: "/order-tracking/:id",
        element: (
          <PrivateRoute>
            <OrderTracking />
          </PrivateRoute>
        ),
      },
      {
        path: "/payment",
        element: <PaymentSuccess />,
      },
      {
        path: "/payment/success",
        element: <PaymentSuccess />,
      },
      {
        path: "/payment/fail",
        element: <PaymentFail />,
      },
      {
        path: "/payment/cancel",
        element: <PaymentCancel />,
      },
      // The API hardcodes these paths into its EPS/Stripe recipe purchase
      // return URLs.
      {
        path: "/recipes/purchase/success",
        element: <RecipePurchaseReturn outcome="success" />,
      },
      {
        path: "/recipes/purchase/fail",
        element: <RecipePurchaseReturn outcome="fail" />,
      },
      {
        path: "/recipes/purchase/cancel",
        element: <RecipePurchaseReturn outcome="cancel" />,
      },
      {
        path: "/invoice/:orderId",
        element: (
          <PrivateRoute>
            <Invoice />
          </PrivateRoute>
        ),
      },
      {
        path: "/terms",
        element: <TermsAndConditions />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/partner-privacy-policy",
        element: <PartnerPrivacyPolicy />,
      },
      {
        path: "/security-policy",
        element: <SecurityPolicy />,
      },
      {
        // Linked from the Play Data safety form as the account-deletion URL,
        // so the path must stay stable once submitted.
        path: "/delete-account",
        element: <DeleteAccount />,
      },
      {
        path: "/governing-law",
        element: <GoverningLaw />,
      },
      {
        // Support tickets have no counterpart in the current API (there is no
        // support module), so these point at the contact form until one exists.
        // The pages themselves are kept under features/support-tickets/.
        path: "/my-tickets",
        element: <Navigate to="/contact-us" replace />,
      },
      {
        path: "/my-tickets/new",
        element: <Navigate to="/contact-us" replace />,
      },
      {
        path: "/under-construction",
        element: <UnderConstruction />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
  {
    path: "/print-order",
    element: <PrintComponent />,
  },
]);
